exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dropdown[data-v-71553e49]{width:100%}.dropdown .caret[data-v-71553e49]{position:absolute;top:10px;right:10px}.dropdown .dropdown-toggle[data-v-71553e49]{width:100%;text-align:left}.dropdown-menu[data-v-71553e49]{width:100%;margin-top:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-71553e49&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App/protected/components/user/MyProfile.vue
// module id = 598
// module chunks = 0